import React from 'react';

const PrivacyModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-6 bg-black/90 backdrop-blur-sm">
      <div className="relative w-full max-w-2xl max-h-[80vh] bg-[#0a0a0a] border border-[#1a1a1a] flex flex-col shadow-2xl">
        
        {/* Header */}
        <div className="p-6 border-b border-[#1a1a1a] flex justify-between items-center bg-[#0d0d0d]">
          <h2 className="font-mono text-xs tracking-[0.3em] text-white uppercase">Privacy_Protocol.v1</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-white transition-colors font-mono text-xs tracking-widest"
          >
            [ CLOSE ]
          </button>
        </div>

        {/* Content Area */}
        <div className="p-6 md:p-8 overflow-y-auto font-mono text-[11px] leading-relaxed text-gray-400 custom-scrollbar">
          <section className="mb-8">
            <h3 className="text-white mb-4 tracking-widest uppercase text-[12px]">01. Data Collection</h3>
            <p className="mb-4">
              SHADE ("we", "us", or "our") collects minimal data necessary to provide our services. By opting into our "Classified Access" (Newsletter), you provide us with your email address. This data is used exclusively for marketing communications and early drop notifications.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-white mb-4 tracking-widest uppercase text-[12px]">02. Tracking & Analytics</h3>
            <p className="mb-4">
              Our interface utilizes advanced tracking protocols including Meta Pixel and Google Analytics 4. These tools collect technical data (IP addresses, device types, user behavior) to optimize our "Anomaly" experience and serve relevant advertising on Tier 1 networks.
            </p>
          </section>

          <section className="mb-8">
            <h3 className="text-white mb-4 tracking-widest uppercase text-[12px]">03. Your Rights (GDPR/CCPA)</h3>
            <p className="mb-4">
              Under international data protection laws, you retain the right to:
            </p>
            <ul className="list-none space-y-2 mb-4 pl-2 border-l border-[#222]">
              <li>— Request access to your stored data.</li>
              <li>— Request immediate deletion ("The Right to be Forgotten").</li>
              <li>— Opt-out of any marketing communication via the "Unsubscribe" link.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h3 className="text-white mb-4 tracking-widest uppercase text-[12px]">04. Security</h3>
            <p>
              Data transmission is encrypted via HTTPS. We do not sell, trade, or transfer your personally identifiable information to outside parties, except for trusted service providers who assist us in operating our node.
            </p>
          </section>

          <div className="pt-8 border-t border-[#1a1a1a] text-[#333]">
            STATUS: COMPLIANT // LOCATION: UNKNOWN // SHADE_LEGAL_DEPT
          </div>
        </div>

        {/* Footer Button */}
        <div className="p-6 bg-[#0d0d0d] border-t border-[#1a1a1a] text-center">
          <button 
            onClick={onClose}
            className="w-full py-3 bg-white text-black font-mono text-[10px] tracking-[0.4em] uppercase hover:bg-gray-200 transition-colors"
          >
            Acknowledge
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyModal;